import { BaseUseCase } from "@domains/useCases/UseCaseBase";
export default class LiveNewsUseCase extends BaseUseCase {
    constructor(commonQuotesHomePageRepository) {
        super();
        this.commonQuotesHomePageRepository = commonQuotesHomePageRepository;
    }
    async fetchResult(requestData) {
        return await this.commonQuotesHomePageRepository.getLiveNewsData(requestData);
    }
}
